import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var Int = props => {
  var {
    Int: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Int');
  return null;
};
Int.displayName = 'JVR.Int';